import styled from 'styled-components';

export const LinkContained = styled.a`
    display: inline-block;
    position: relative;
    min-width: 64px;
    padding: 10px 20px 10px 20px;
    font-family: Roboto,sans-serif;
    font-size: 0.875rem;
    -webkit-letter-spacing: 0.078125rem;
    -moz-letter-spacing: 0.078125rem;
    -ms-letter-spacing: 0.078125rem;
    letter-spacing: 0.078125rem;
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    overflow: hidden;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    color: #fff;
    border: none;
    background-color: #50bea4;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    -webkit-transition: background-color 250ms cubic-bezier(0.4,0,0.2,1) 0ms,box-shadow 250ms cubic-bezier(0.4,0,0.2,1) 0ms;
    transition: background-color 250ms cubic-bezier(0.4,0,0.2,1) 0ms,box-shadow 250ms cubic-bezier(0.4,0,0.2,1) 0ms;

    &:hover {
        background-color: #50bea4;
        box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
    }
`;